import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import GlobalState, { watchVideo } from '../../../stores/GlobalState'
import classNames from 'classnames'
import { ReactComponent as Play } from '../../../assets/Rectangle 6.svg'
import { ReactComponent as Stop } from '../../../assets/Rectangle 7.svg'
import { isMobile } from '../../../hooks/detect'
import './index.scss'

const Parallax = observer(
  ({
    src,
    type = 'img',
    poster,
    openHere = false,
  }: {
    src: string
    type?: string
    poster?: string | null
    openHere?: boolean
  }) => {
    const video = useRef<any>(null)
    const [isPlay, setPlay] = useState(false)
    const fullScreen = () => {
      var elem: any = video.current
      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    }
    const playVideo = () => {
      if (!video.current) return
      if (video.current.paused) {
        const videos = document.querySelectorAll('video')
        videos.forEach((v) => {
          if (!v.paused) v.pause()
        })
        video.current.play()
        fullScreen()
      } else {
        video.current.pause()
      }
      setPlay(!isPlay)
    }

    useEffect(() => {
      if (GlobalState.video.show) {
        setPlay(true)
      } else setPlay(false)
    }, [GlobalState.video])

    return (
      <div className="image-wrapper">
        {type == 'img' ? (
          <img src={src} />
        ) : (
          <>
            <video
              ref={video}
              poster={poster || ''}
              src={src}
              autoPlay={false}
              preload={'preload'}
              controls={false}
            >
              <source src={src} type="video/mp4"></source>
            </video>
            <div
              className={classNames('image-wrapper__play', isPlay && 'hide')}
              onClick={() => {
                watchVideo(src, poster!)
              }}
            >
              {!isPlay ? (
                <>
                  <span>
                    <Play />
                  </span>
                </>
              ) : (
                <Stop />
              )}
            </div>
          </>
        )}
      </div>
    )
  },
)
export default Parallax
